export const ROLES = {
    Free: 'Free',
    Superuser: 'Superuser',
    Suspended: 'Suspended',
    Pro: 'Pro'
}